// extracted by mini-css-extract-plugin
module.exports = {"v360Tutorial":"V360Tutorial","fade":"fade","isHidden":"is-hidden","v360TutorialGesture":"V360Tutorial-gesture","drag":"drag","v360TutorialHand":"V360Tutorial-hand","tap":"tap"};